export enum DelivererTypeEnum {
    CommunityInstructor = 1,
    PGAProfessional = 2,
    PGAAssociate = 3
}